import * as z from 'zod'
import { NotificationTokenTypes } from '~/shared/config/enums'
import { ApiModel } from '../core'

const schema = z.object({
  deviceId: z.string(),
  token: z.string(),
  tokenType: z.nativeEnum(NotificationTokenTypes),
})

export type PushTokensAttributes = z.infer<typeof schema>

export class PushTokens extends ApiModel<typeof schema, PushTokensAttributes> {
  static jsonApiType = 'push-tokens'

  static schema = schema
}
